import React, { useEffect, useState } from 'react';
import { supabase } from '../../auth';
import { motion } from 'framer-motion';

export const TrashPage: React.FC = () => {
  const [deletedCompanies, setDeletedCompanies] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDeleted();
  }, []);

  const fetchDeleted = async () => {
    try {
      setLoading(true);
      // Sadece silinmiş şirketleri çekiyoruz
      const { data, error } = await supabase
        .from('companies')
        .select('*')
        .not('deleted_at', 'is', null)
        .order('deleted_at', { ascending: false });

      if (error) throw error;
      setDeletedCompanies(data || []);
    } catch (err) {
      console.error('Failed to load trash:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleRestore = async (id: string) => {
    try {
      const { error } = await supabase
        .from('companies')
        .update({ deleted_at: null, deleted_by: null })
        .eq('id', id);

      if (error) throw error;
      fetchDeleted(); // Refresh list
    } catch (err) {
      alert('Failed to restore item.');
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex items-center justify-between backdrop-blur-md bg-white/30 dark:bg-red-900/10 p-6 rounded-2xl shadow-xl border border-red-500/20"
      >
        <div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-red-600 to-pink-600 bg-clip-text text-transparent">
            Trash Bin
          </h1>
          <p className="text-gray-500 dark:text-gray-400 mt-2">
            View and restore soft-deleted entities securely.
          </p>
        </div>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {loading ? (
          <div className="col-span-full py-12 text-center">Loading...</div>
        ) : deletedCompanies.length === 0 ? (
          <div className="col-span-full py-12 text-center text-gray-500 bg-white/40 dark:bg-gray-900/40 rounded-3xl border border-white/20">
            Trash is empty.
          </div>
        ) : (
          deletedCompanies.map((company) => (
            <motion.div
              key={company.id}
              whileHover={{ y: -5 }}
              className="backdrop-blur-xl bg-white/50 dark:bg-gray-800/50 p-6 rounded-3xl shadow-lg border border-white/30 flex flex-col justify-between"
            >
              <div>
                <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100">{company.name}</h3>
                <p className="text-sm text-gray-500 mt-2">
                  Deleted on: {new Date(company.deleted_at).toLocaleDateString()}
                </p>
              </div>
              <button
                onClick={() => handleRestore(company.id)}
                className="mt-6 w-full py-3 bg-gradient-to-r from-emerald-400 to-teal-500 hover:from-emerald-500 hover:to-teal-600 text-white font-semibold rounded-xl shadow-md transition-all duration-300 transform"
              >
                Restore Entity
              </button>
            </motion.div>
          ))
        )}
      </motion.div>
    </div>
  );
};
